const Accordion = {
	expandedClass: 'expanded',
	initializedClass: 'accordion-initialized',
	init: () => {
		let elements = document.querySelectorAll('[data-accordion]:not(.'+Accordion.initializedClass+')');
		if(!elements)
			return;

		elements.forEach((elem) => {
			Accordion.start(elem);
		});

		let elementsMobile = document.querySelectorAll('[data-accordion-mobile]:not(.'+Accordion.initializedClass+')');
		if(!elementsMobile || window.innerWidth > 768)
			return;

		elementsMobile.forEach((elem) => {
			Accordion.start(elem);
		});
	},
	start: (elem) => {
		const headerElement = elem.querySelector('[data-accordion-header]');
		const bodyElement = elem.querySelector('[data-accordion-body]');
		if(headerElement && bodyElement){
			elem.classList.add(Accordion.initializedClass);
			headerElement.addEventListener('click', (ev) => {
				ev.preventDefault();
				const isExpanded = elem.classList.contains(Accordion.expandedClass);
				if(!isExpanded){
					Accordion.closeOther(elem);
				}
				Accordion.setOpen(elem, bodyElement, !isExpanded);
			})
		}


	},
	setOpen: (elem, bodyElement, open) => {
		elem.classList.toggle(Accordion.expandedClass, open);
		if(!open){
			bodyElement.style.height = "0px";
		}else{
			bodyElement.style.height = bodyElement.scrollHeight+"px";
		}
	},
	closeOther: (elem) => {
		let accordionGroup = elem.closest('[data-accordion-group]');
		if(!accordionGroup){
			accordionGroup = document.body;
		}
		const accordionsToClose = accordionGroup.querySelectorAll('[data-accordion]');
		if(!accordionsToClose)
			return;
		accordionsToClose.forEach((accordionToClose) => {
			const accordionToCloseBody = accordionToClose.querySelector('[data-accordion-body]');
			if(accordionToCloseBody){
				Accordion.setOpen(accordionToClose, accordionToCloseBody, false);
			}
		});
	}
}

export default Accordion;
